import React from 'react';
import { Heading, Icon, Loader, ModalBox, useMediaQueryContext, useModalContext, } from '@fourthwall/components';
import { ArrowShortLeftIcon } from '@fourthwall/icons';
import { SectionItem } from '../SectionItemV2';
import { IFramePreview } from './components/IFramePreview/IFramePreview';
import { useRecommendations } from './hooks/useRecommendations';
import * as S from './styled';
export const AddSectionModalView = ({ blockId, sections, selectedSection, onCreateLayoutSection, filterSections, onSectionSelect, }) => {
    const { close } = useModalContext();
    const media = useMediaQueryContext();
    const { recommendations } = useRecommendations({ sections });
    const renderLoader = () => {
        if (sections)
            return null;
        return (React.createElement(S.LoaderWrapper, null,
            React.createElement(Loader, { size: "large" })));
    };
    const renderSectionItems = (sections) => {
        const filteredSections = sections.filter((s) => !filterSections.includes(s.sectionType));
        return filteredSections.map((item) => (React.createElement(SectionItem, { key: item.sectionType, section: item, active: selectedSection === item, onClick: () => onSectionSelect(item) })));
    };
    const renderRecommendedSection = () => {
        if (!recommendations)
            return null;
        return (React.createElement(S.SectionWrapper, null,
            React.createElement(S.SectionContent, null,
                React.createElement(SectionItem, { section: { sectionType: 'recommended', name: 'Recommended', presets: [] }, active: selectedSection === 'Recommended', onClick: () => onSectionSelect('Recommended') }))));
    };
    const renderPreview = (section) => {
        if (section === 'Recommended') {
            if (!recommendations)
                return null;
            return (React.createElement(S.RecommendedContainer, null, recommendations?.map(({ group, sections }) => (React.createElement(S.RecommendedGroup, null,
                React.createElement(S.RecommendedGroupTitle, null, group),
                React.createElement(S.PreviewsGrid, null, sections.map((section) => (React.createElement(IFramePreview, { key: section.sectionType, url: section.presets[0].previewUrl, fluid: true, align: "start", onClick: () => onCreateLayoutSection(section.sectionType, blockId, section.platformAppId, section.presets[0].name) })))))))));
        }
        if (section.presets.length === 1) {
            return (React.createElement(S.SinglePreviewContainer, null, section.presets.map((preset) => (React.createElement(IFramePreview, { key: preset.name, url: preset.previewUrl, onClick: () => onCreateLayoutSection(section.sectionType, blockId, section.platformAppId, preset.name) })))));
        }
        return (React.createElement(S.PreviewsGrid, null, section.presets.map((preset) => (React.createElement(IFramePreview, { key: preset.name, url: preset.previewUrl, onClick: () => onCreateLayoutSection(section.sectionType, blockId, section.platformAppId, preset.name) })))));
    };
    const renderContent = () => {
        if (!sections)
            return null;
        if (media.tablet) {
            return (React.createElement(S.Content, null,
                React.createElement(S.Sidebar, null,
                    React.createElement(S.HeadingContainer, null,
                        React.createElement(Heading, { type: "h3", weight: "semibold" }, "Add new section")),
                    renderRecommendedSection(),
                    sections.map(({ group, sections }) => (React.createElement(S.SectionWrapper, { key: group },
                        React.createElement(S.SectionHeader, null, group),
                        React.createElement(S.SectionContent, null, renderSectionItems(sections)))))),
                selectedSection && (React.createElement(S.PreviewsContainer, null, renderPreview(selectedSection)))));
        }
        if (selectedSection) {
            return (React.createElement(S.Sidebar, null,
                React.createElement(S.HeadingContainer, { onClick: () => onSectionSelect(null) },
                    React.createElement(Icon, { component: ArrowShortLeftIcon, height: 16 }),
                    React.createElement(Heading, { type: "h3", weight: "semibold" }, selectedSection === 'Recommended' ? selectedSection : selectedSection.name)),
                React.createElement(S.PreviewsContainer, null, renderPreview(selectedSection))));
        }
        return (React.createElement(S.Sidebar, null,
            React.createElement(S.HeadingContainer, null,
                React.createElement(Heading, { type: "h3", weight: "semibold" }, "Add new section")),
            renderRecommendedSection(),
            sections.map(({ group, sections }) => (React.createElement(S.SectionWrapper, { key: group },
                React.createElement(S.SectionHeader, null, group),
                React.createElement(S.SectionContent, null, renderSectionItems(sections)))))));
    };
    return (React.createElement(ModalBox, { maxWidth: 1400, disableScrolling: true, withoutPadding: true, onClose: close },
        renderLoader(),
        renderContent()));
};
